import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a8bbda9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "fa-ul" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-up" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.asc && _ctx.asc(...args))),
          title: "Sortera stigande",
          class: _normalizeClass(["fa-li", { active: _ctx.isDesc !== true && _ctx.isEnabled }])
        }, _hoisted_4, 2)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.desc && _ctx.desc(...args))),
          title: "Sortera fallande",
          class: "fa-li"
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["fas fa-angle-down", { active: _ctx.isDesc === true && _ctx.isEnabled }])
          }, null, 2)
        ])
      ])
    ])
  ]))
}